<div class="users-header-container">
  <h2 class="header-title">Locations</h2>
</div>
@if (customer.group_id){
  <div class="grid-wrapper">
    <ag-grid-angular
      style="width: 100%; height: 100%;"
      class="ag-theme-alpine"
      [rowData]="rowData"
      [columnDefs]="colDefs"
      [defaultColDef]="defaultColDef"
      [sideBar]="sideBar"
      [gridOptions]="gridOptions"
      [loading]="gridLoading"
      (gridReady)="onGridReady($event)"
      (cellValueChanged)="onCellValueChanged($event)"
    />
  </div>
} @else {
  <h3>Please, add "Group ID"</h3>
}
